import React from "react";
import { TextFieldWithoutBorders } from "../TextFieldWithoutBorders";

const MinutesPicker = (props: any) => {
    const { value, manageChange } = props;
    const [minutes, setMinutes] = React.useState(value || '');

    return (
        <TextFieldWithoutBorders 
        value={minutes}
        handleChange={(e:any) => {setMinutes(e.target.value)}}
        type="number"
        manageOnBlur={(e:any) => {manageChange(e.target.value)}}
        />
    );
}

export default MinutesPicker;